export class User {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  role: string;
  createdOn: string;
  modifiedOn: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts